export default {
  nav: {
    collection: '收藏',
    scan: '掃描',
    cards: '卡牌表',
    profile: '帳戶',
  },
  common: {
    all: '全部',
    search: '搜尋',
    cancel: '取消',
    confirm: '確認',
    noData: '暫無資料',
    success: '成功',
    loading: '加載中...',
    ownedOnly: '僅顯示已擁有',
    edit: '編輯',
    delete: '刪除',
    save: '保存',
    langJa: '日語',
    langEn: '英語',
    pullRefresh: '下拉刷新',
    releaseRefresh: '放開即可刷新',
    noMore: '全部加載完畢',
  },
  toast: {
    networkError: '網路錯誤，請檢查連線',
    timeout: '請求逾時，請重試',
    invalidRequest: '請求無效',
    sessionExpired: '登錄已過期，請重新登錄',
    accessDenied: '存取被拒',
    notFound: '資源不存在',
    invalidParams: '參數錯誤',
    tooManyRequests: '請求過於頻繁，請稍候',
    serverError: '伺服器錯誤，請稍後再試',
    loginRequired: '請先登錄',
    addSuccess: '已加入收藏',
    removeSuccess: '已移除收藏',
    quantityUpdated: '數量已更新',
    saveSuccess: '儲存成功',
    signOutSuccess: '已登出',
    searchEmpty: '請輸入卡牌編號',
    uploadSuccess: '上傳成功',
    notCamera: '無法存取攝像頭，請確認權限。',
    firstCard: '已經是第一張卡片了',
    lastCard: '已經是最後一張卡片了',
    emailEmpty: '請輸入電子郵件地址',
    emailInvalid: '請輸入有效的電子郵件地址',
    codeEmpty: '請輸入 6 位驗證碼',
    addSuccess: '已添加到收藏',
    googleSdkNotReady: 'Google 服務尚未就緒，請稍後再試',
    linkCopied: '鏈結已複製！',
  },
  signin: {
    subtitle: '航海王集卡追蹤器',
    emailLabel: '電子郵件',
    emailPlaceholder: 'captain@grandline.com',
    verificationCode: '驗證碼',
    send: '發送',
    resend: '重新發送',
    signIn: '登錄',
    autoRegister: '新用戶將自動完成註冊',
    quickLogin: '快速登錄方式', // ← 加这两行
    lastLogin: '上次登錄',
  },
  collection: {
    searchPlaceholder: '搜尋卡牌、系列、編號…',
    searchedCards: '搜尋結果',
    totalValue: '收藏總價值',
    totalCards: '卡牌總數',
    sortHighToLow: '價格：由高到低',
    sortLowToHigh: '價格：由低到高',
    recentlyAdded: '最新收藏',
    guestTitle: '開始你的收藏之旅',
    guestDesc: '登錄後即可追蹤、管理並評估你的卡牌收藏價值',
    guestFeature1: '記錄每一張你擁有的卡牌',
    guestFeature2: '即時監控市場價格動態',
    guestFeature3: '使用鏡頭快速掃描識別卡牌',
    emptyTitle: '您的收藏為空',
    emptyDesc: '透過掃描或搜尋卡牌，建立您的收藏',
    scanCards: '掃描卡牌',
    searchCards: '搜尋卡牌',
    gradedValue: '評級卡價值',
    ungradedValue: '裸卡價值',
    filter: '篩選',
    filterTitle: '篩選與排序',
    sortBy: '排序方式',
    language: '語言',
    langJP: '日語',
    langEN: '英語',
    cardType: '卡牌類型',
    cardTypeAll: '全部',
    cardTypeGraded: '評級卡',
    cardTypeRaw: '裸卡',
    resetFilter: '重置',
    applyFilter: '套用篩選',
    plLabel: '盈虧',
    sortPnlHighToLow: '盈虧：由高至低',
    sortPnlLowToHigh: '盈虧：由低至高',
    select: '選擇',
    selectedCount: '已選擇 {count}',
    selectAll: '選全部',
    move: '移動',
    delete: '刪除',
    moveToGroup: '移動到分組',
    moveCards: '將 {count} 張卡移動到：',
    confirmMove: '確認移動',
    moveSuccess: '移動成功',
    deleteConfirmMsg: '確認刪除 {count} 張卡嗎？刪除後不可恢復。',
    confirmDelete: '確認刪除',
    deleteSuccess: '刪除成功',
  },
  cardDetail: {
    title: '卡牌詳情',
    cardId: '卡牌編號',
    rarity: '稀有度',
    language: '語言',
    version: '版本',
    type: '類型',
    foil: '閃卡',
    yourHolding: '我的持有',
    owned: '持有數量',
    market: '市場價格',
    lastUpdated: '最後更新',
    ungradedPrice: '裸卡市價',
    totalValue: '總收藏價值',
    addToCollection: '添加到收藏',
    addCard: '添加卡牌',
    cardCondition: '品相',
    selectCondition: '選擇品相',
    totalPaid: '總成本價',
    pricePerCard: '成本價',
    qtyMinError: '數量至少為 1',
    totalPaidRequired: '請輸入總買入金額',
    profitLabel: '盈虧',
    gradeHint: '*新增後不能更改評級',
    remove: '移除',
    profitableGrades: '評級獲利分析',
    moreGrades: '更多評級',
    marketPrices: '市場價格',
    convertHint: '平台將以美元換算',
  },
  scan: {
    title: '掃描',
    manual: '手動輸入',
    alignCard: '將卡牌對準框內',
    scanCard: '掃描卡牌以識別',
    searchCards: '搜尋卡牌',
    scanBtn: '掃描',
    pointCamera: '對準卡牌 · 保持穩定',
    unidentified: '未能識別卡牌',
    cardsIdentified: '張卡牌已識別',
    scanSuccess: '識別成功',
    cardLanguage: '卡牌語言',
    cardId: '卡牌編號',
    cardIdPlaceholder: '例：OP01-060',
    tapToCapture: '點擊下方按鈕拍照',
    takePhoto: '拍攝照片',
    fromAlbum: '從相簿選擇',
    clear: '清空',
    qty: '數量',
    rescan: '重新掃描',
    failedHint: '幫助補充卡牌資料，審核通過後可獲得貝利積分，用於兌換獎勵',
    alignLabel: '評級標籤對準此處',
    failedFeedbackDesc: '結果不準確，提交卡牌問題',
  },
  cards: {
    searchPlaceholder: '搜尋系列…',
    searchInSet: '搜尋卡牌…',
    allSets: '全部系列',
    of: 'of',
  },
  setDetail: {
    sortPriceDesc: '價值：由高至低',
    sortPriceAsc: '價值：由低至高',
    sortByNumber: '按編號排列',
  },
  profile: {
    email: '電子郵件',
    language: '語言',
    langEn: 'English',
    langZhTW: '繁體中文',
    editUsername: '修改用戶名',
    usernamePlaceholder: '請輸入用戶名',
    saveUsername: '儲存',
    editAvatar: '更換頭像',
    signOut: '登出',
    guest: '開始你的收藏之旅',
    guestDesc: '登錄後即可追蹤、管理並評估你的卡牌收藏價值',
    feature1: '追蹤並管理你的卡牌收藏',
    feature2: '即時監控市場價格動態',
    feature3: '使用鏡頭快速掃描識別卡牌',
    loginMethod: '登錄方式管理',
    googleAccount: 'Google 帳號',
    notBound: '未綁定',
    bind: '綁定',
    unbind: '解綁',
    googleBound: 'Google 帳號已綁定',
    googleUnbound: 'Google 帳號已解綁',
    keepOneLogin: '至少需要保留一個登錄方式',
    bound: '已綁定',
    currency: '幣種單位',
    aboutUs: '關於我們',
    termsDoc: '《平台法律條例》',
    privacyDoc: '《用戶個人隱私條例》',
    currencyUSD: '美元',
    currencyHKD: '港幣',
    currencyJPY: '日圓',
    feedbackHistory: '反饋歷史',
  },
  report: {
    title: '反饋問題',
    imageIssue: '圖片異常',
    priceIssue: '價格異常',
    missingCard: '缺少卡牌',
    other: '其他',
    placeholder: '請描述該問題。',
    submit: '提交',
    successToast: '反饋成功',
    feedback: '意見反饋',
    uploadImage: '附件',
    optional: '（選填）',
    uploadHint: '新增圖片',
    uploadImageLabel: '圖片',
    rewardHint: '幫助補充卡牌資料，審核通過後可獲得貝利積分，用於兌換獎勵',
  },
  asset: {
    totalValue: '收藏總價值',
    totalSpent: '買入成本',
    change: '總盈虧',
    ungraded: '裸卡',
    graded: '評級卡',
    valueTrend: '價值走勢',
    topTreasures: 'Top Treasures',
    ungraded_label: '裸卡',
    noData: '暫無資料',
    ungradedLabel: '裸卡',
    paid: '已付',
    value: '價值',
    qty: '數量',
    topGainersTitle: '市場漲幅最高卡牌',
    topGainersSubtitle: '依據市場價格漲幅排序',
    totalPaid: '總成本',
    guestBadge: '管理資產',
    guestTitleLine1: '掃描、收藏與',
    guestTitleLine2: '掌握你的卡牌',
    viewMore: '檢視更多',
    viewLess: '檢視更少',
    noCollectionData: '還沒有收藏資料',
  },
  trend: {
    priceTrend: '價格趨勢',
    ungraded: '未評級',
    graded: '評級卡',
    pop: '流行度',
  },
  feedback: {
    resolved: '已處理',
    processing: '處理中',
    closed: '已關閉',
    viewCard: '查看卡牌',
  },
  group: {
    title: '我的分組',
    viewing: '檢視',
    newGroup: '新建分組',
    manage: '管理分組',
    default: '默認',
    done: '完成',
    inputPlaceholder: '輸入分組名稱（最多20字）',
    create: '創建',
    createSuccess: '分組已創建',
    renameSuccess: '重命名成功',
    deleteSuccess: '分組已刪除',
    deleteConfirmTitle: '刪除分組',
    deleteConfirmMsg:
      '確認刪除分組「{name}」嗎？\n{count} 張卡將默認移入「{defaultGroup}」。',
    confirmDelete: '刪除',
    allGroupsDesc: '查看所有收藏卡牌',
    currentGroup: '當前分組',
    cards: '張卡',
  },
}
